import { PriceReportMessage } from "./priceReportMessage"

export class StoredPriceReportMessage extends PriceReportMessage {

}